/*=========================================================================================
  File Name: getters.js
  namespace: users
  Description: Vuex Store - User getters
==========================================================================================*/

const getters = {
  getCurrentUser: state => {
    return { ...state.currentUser }
  },
  getUserToken: state => {
    return state.currentUser.token
  },
  getUserProfile: state => {
    return state.currentUser.profile.data
  },
  hasAccessRol: state => {
    return state.currentUser.roles.data.some(r => r.name.toLowerCase() === 'content creator' || r.name.toLowerCase() === 'admin')
  }
}

export default getters
